import { render, staticRenderFns } from "./ImportsPage.vue?vue&type=template&id=b896e8be&scoped=true&"
import script from "./ImportsPage.vue?vue&type=script&lang=js&"
export * from "./ImportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b896e8be",
  null
  
)

export default component.exports